<template>
  <div>
    <v-subheader class="title-setting">Descargar App</v-subheader>

    <v-form ref="form" class="py-4 px-4">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            :model-value="mobile_app_version"
            label="Ultima version"
            readonly
            persistent-hint
          />

          <v-text-field
            :model-value="mobile_app_download_url"
            label="Link de descarga"
            readonly
            persistent-hint
            :disabled="!mobile_app_download_url"
            prepend-inner-icon="mdi-open-in-new"
            class="cursor-pointer"
            @click="openDownloadUrl"
          />
        </v-col>

        <v-col cols="12" md="6" class="text-center">
          <p class="text-subtitle-2 mb-2">QR de descarga</p>
          <QrcodeCanvas
            :value="mobile_app_download_url"
            :size="200"
            level="M"
          />
        </v-col>

        <v-col cols="12" class="mt-2">
          <v-alert type="primary" variant="tonal">
            <p class="mb-2">📢 <strong>Importante - Configuracion del escaner</strong></p>
            <p class="mb-2">
              Para el correcto funcionamiento de la app WMS, es necesario que el dispositivo handheld tenga habilitada la opcion de
              <strong>enviar "ENTER" automaticamente despues de cada escaneo</strong>.
            </p>
            <p class="mb-2">
              Esta configuracion permite que los codigos se carguen correctamente en la app sin necesidad de intervencion manual.
            </p>
            <p class="mb-2">Si no esta activada, pueden experimentar problemas al escanear productos.</p>
            <p class="mb-0">Ante cualquier duda, consulta con soporte.</p>
          </v-alert>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { generalService } from "@/libs/ws/generalService";
import { QrcodeCanvas } from "qrcode.vue";

export default {
  components: {
    QrcodeCanvas,
  },
  data() {
    return {
      mobile_app_version: "No configurada",
      mobile_app_download_url: "",
    };
  },
  mounted() {
    this.loadMobileAppInfo();
  },
  methods: {
    openDownloadUrl() {
      if (!this.mobile_app_download_url) return;
      window.open(this.mobile_app_download_url, "_blank", "noopener,noreferrer");
    },
    loadMobileAppInfo() {
      generalService
        .request("app-version")
        .then((response) => {
          if (response?.status && response?.result) {
            this.mobile_app_version = response.result.version || "No configurada";
            this.mobile_app_download_url = response.result.url && response.result.url !== "-" ? response.result.url : "";
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.cursor-pointer :deep(input) {
  cursor: pointer;
}
</style>
